import './broker-form.scss';

import RestoreIcon from '@mui/icons-material/Restore';
import { Typography } from '@mui/material';

type Props = {
  isBroker?: boolean;
  onClickReactivate?: () => void;
};

export const ActivateBrokerBrokerage = ({
  isBroker,
  onClickReactivate,
}: Props) => {
  return (
    <span
      onClick={onClickReactivate}
      style={{ display: 'flex', alignItems: 'center' }}
      data-testid="reactivate-broker-button"
    >
      <RestoreIcon
        sx={{
          height: '24px',
          width: '24px',
          marginRight: '4px',
          marginBottom: '2px',
        }}
      />
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
        }}
      >
        REACTIVATE {isBroker ? 'BROKER' : 'BROKERAGE'}
      </Typography>
    </span>
  );
};
